import React from "react";
const HEADER_IMAGE_URL = "https://e-templates.s3-us-west-1.amazonaws.com/default/logo_alertmedia_public_templates.png";
import RichMessage from "./RichMessage";

const Header = ({ imageUrl, name, summary }) => {
  return (
    <>
      <div id="header" data-cy="header">
        <div>
          <div>
            <img id="header-image" src={imageUrl || HEADER_IMAGE_URL} title={name} alt={name} />
          </div>
          <div className="intro">
            <div>
              <strong>{name}</strong>
            </div>
          </div>
        </div>
      </div>
      <div className="summary">
        <RichMessage>{summary}</RichMessage>
      </div>
    </>
  );
};

export default Header;
